module.exports = __webpack_public_path__ + "static/hero_sp_detail-744e5bd1785017ebcb1cb3528ac3f720.png";